import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import "@mescius/wijmo.cultures/wijmo.culture.en";
import "@mescius/wijmo.cultures/wijmo.culture.en-GB";
import "@mescius/wijmo.cultures/wijmo.culture.es";
import "@mescius/wijmo.cultures/wijmo.culture.de";
import "@mescius/wijmo.cultures/wijmo.culture.it";
import "@mescius/wijmo.cultures/wijmo.culture.fr";
import "@mescius/wijmo.cultures/wijmo.culture.pt";
import "@mescius/wijmo.cultures/wijmo.culture.ru";
import "@mescius/wijmo.cultures/wijmo.culture.ja";
import "@mescius/wijmo.cultures/wijmo.culture.ko";
import "@mescius/wijmo.cultures/wijmo.culture.zh";
import {AppVersion} from './app/app.version';

import '@fluentui/web-components/field.js';
import '@fluentui/web-components/label.js';
import '@fluentui/web-components/divider.js';
import '@fluentui/web-components/text.js';
import '@fluentui/web-components/text-input.js';
import '@fluentui/web-components/textarea.js';
import '@fluentui/web-components/button.js';
import '@fluentui/web-components/anchor-button.js';
import '@fluentui/web-components/toggle-button.js';
import '@fluentui/web-components/switch.js';
import '@fluentui/web-components/checkbox.js';
import '@fluentui/web-components/dropdown.js';
import '@fluentui/web-components/listbox.js';
import '@fluentui/web-components/option.js';
import '@fluentui/web-components/badge.js';
import '@fluentui/web-components/progress-bar.js';
import '@fluentui/web-components/tooltip.js';
import '@fluentui/web-components/link.js';
import '@fluentui/web-components/slider.js';
import '@fluentui/web-components/radio-group.js';
import '@fluentui/web-components/radio.js';

import {setTheme} from '@fluentui/web-components';
import {BrandVariants, createLightTheme} from '@fluentui/tokens';
import chroma from 'chroma-js';

const baseColor = 'rgb(194, 27, 23)'; //`#c21b17`;

function colorSize(size: number): number {
    if (size < 100) return Math.abs((size - 100) / 100.0);
    else return Math.abs((size - 100) / 50.0);
}

const myBrand: BrandVariants = {
    10: chroma(baseColor).darken(colorSize(10)).hex(),
    20: chroma(baseColor).darken(colorSize(20)).hex(),
    30: chroma(baseColor).darken(colorSize(30)).hex(),
    40: chroma(baseColor).darken(colorSize(40)).hex(),
    50: chroma(baseColor).darken(colorSize(50)).hex(),
    60: chroma(baseColor).darken(colorSize(60)).hex(),
    70: chroma(baseColor).darken(colorSize(70)).hex(),
    80: chroma(baseColor).darken(colorSize(80)).hex(),
    90: chroma(baseColor).darken(colorSize(90)).hex(),
    100: baseColor,
    110: chroma(baseColor).brighten(colorSize(110)).hex(),
    120: chroma(baseColor).brighten(colorSize(120)).hex(),
    130: chroma(baseColor).brighten(colorSize(130)).hex(),
    140: chroma(baseColor).brighten(colorSize(140)).hex(),
    150: chroma(baseColor).brighten(colorSize(150)).hex(),
    160: chroma(baseColor).brighten(colorSize(160)).hex(),
};

const appTheme = createLightTheme(myBrand);
appTheme.spacingHorizontalM = '10px';

setTheme(appTheme as any);

console.log(`%cPortfolio Management Front version ${AppVersion.version}`, 'color: white; background: red; font-size: 30px; width: 200px; padding: 10px;');
console.log(`%c©2025-2026 Assicurazioni Generali SPA, etractive.de`, 'padding: 0 10px');
console.log(`%cRevision: ${AppVersion.revision}, Branch: ${AppVersion.branch}, Tags: ${AppVersion.tags}`, 'width: 100%; border-bottom: 1px solid black; padding: 0 10px;');

//provideFluentDesignSystem().register(allComponents);

bootstrapApplication(AppComponent, appConfig())
    .then(appRef => {})
    .catch(err => console.error(err))
